<template>
  <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
    <span class="cursor-pointer flex items-center i18n-locale">
      <img class="h-4 w-5" :src="i18n_locale_img" :alt="$i18n.locale" />
      <span class="hidden sm:block ml-2">{{ $t('layout.nav-bar.' + getCurrentLocaleData.lang) }}</span>
    </span>
    <vs-dropdown-menu class="w-48 i18n-dropdown vx-navbar-dropdown">
      <vs-dropdown-item @click="updateLocale('en')"><img class="h-4 w-5 mr-1" src="@/assets/images/flags/en.png" alt="en" /> &nbsp;{{$t('layout.nav-bar.english')}}</vs-dropdown-item>
      <vs-dropdown-item @click="updateLocale('th')"><img class="h-4 w-5 mr-1" src="@/assets/images/flags/th.png" alt="fr" /> &nbsp;{{$t('layout.nav-bar.thai')}}</vs-dropdown-item>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
export default {
  computed: {
    i18n_locale_img () {
      return require(`@/assets/images/flags/${this.$i18n.locale}.png`)
    },
    getCurrentLocaleData () {
      const locale = this.$i18n.locale
      if (locale === 'en') return {flag: 'us', lang: 'english'}
      else return {flag: 'th', lang: 'thai'}
    }
  },
  methods: {
    updateLocale (locale) {
      localStorage.setItem('currentLanguage', locale)
      this.$i18n.locale = locale
    }
  }
}
</script>
